import * as React from 'react'
export function DollarBadge({ title, className, ...props }) {
  return (
    <svg
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      viewBox="15 12 31 34"
      className={className}
      {...props}
    >
      <title>{title}</title>
      <g filter="url(#filter0_dd_1283_578)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.4982 12C29.8163 12 29.1309 12.2136 28.5542 12.6445L26.933 13.8709C26.3672 14.2945 25.6708 14.5191 24.9709 14.5154L22.9616 14.497C21.529 14.4933 20.2559 15.4399 19.8171 16.8357L19.2005 18.8097C18.9865 19.4911 18.5695 20.0804 18 20.5002L16.3643 21.7119C15.2037 22.5737 14.7177 24.1058 15.1638 25.498L15.7949 27.4536C16.0125 28.1349 16.0125 28.8605 15.7949 29.5418L15.1638 31.5159C14.7177 32.908 15.2037 34.4217 16.3643 35.2798L18 36.4915C18.5695 36.9114 18.9865 37.5154 19.2005 38.2004L19.8171 40.156C20.2559 41.5482 21.5326 42.4984 22.9616 42.4947H24.9709C25.6745 42.4947 26.3672 42.7193 26.933 43.1392L28.5542 44.3509C29.7112 45.2164 31.2888 45.2164 32.4458 44.3509L34.067 43.1392C34.6328 42.7157 35.3292 42.491 36.0291 42.4947H38.0384C39.471 42.4984 40.7441 41.5519 41.1829 40.156L41.7995 38.2004C42.0135 37.519 42.4305 36.9114 43 36.4915L44.6357 35.2798C45.7963 34.4254 46.2823 32.908 45.8362 31.5159L45.2051 29.5418C44.9875 28.8605 44.9875 28.1349 45.2051 27.4536L45.8362 25.498C46.2823 24.1058 45.7963 22.5737 44.6357 21.7156L43 20.5039C42.4305 20.084 42.0135 19.4948 41.7995 18.8134L41.1829 16.8394C40.7441 15.4472 39.4674 14.497 38.0384 14.5007L36.0291 14.5191C35.3255 14.5191 34.6328 14.2945 34.067 13.8746L32.4458 12.6482C31.909 12.2468 31.2852 12.0331 30.6578 12.0037H30.5018L30.4982 12Z"
          fill="white"
        />
        <path
          d="M26.933 43.1392L28.5542 44.3509C29.7112 45.2164 31.2888 45.2164 32.4458 44.3509L34.067 43.1392M26.933 43.1392L41.1829 40.156C40.7441 41.5519 39.471 42.4984 38.0384 42.4947H36.0291M26.933 43.1392C26.3672 42.7193 25.6745 42.4947 24.9709 42.4947M26.933 43.1392L24.9709 42.4947M34.067 43.1392C34.6328 42.7157 35.3292 42.491 36.0291 42.4947M34.067 43.1392L33.4683 42.3382M34.067 43.1392L33.4677 42.3387M36.0291 42.4947L36.0344 41.4947C36.0335 41.4947 36.0326 41.4947 36.0317 41.4947M36.0291 42.4947V41.4947H36.0317M36.0317 41.4947H38.0384H38.041C39.0233 41.4972 39.9176 40.8465 40.2289 39.8561L40.2292 39.8553L40.8454 37.9008L33.4683 42.3382M36.0317 41.4947C35.1188 41.4905 34.2107 41.7827 33.4683 42.3382M33.4683 42.3382L33.4677 42.3387M33.4683 42.3382C33.4681 42.3384 33.4679 42.3385 33.4677 42.3387M33.4683 42.3382L33.4677 42.3387M33.4677 42.3387L31.8471 43.5499L31.8468 43.5501C31.045 44.15 29.955 44.15 29.1532 43.5501L29.1529 43.5499L27.5317 42.3382L27.5289 42.3362C26.7876 41.7861 25.8851 41.4947 24.9709 41.4947L22.9616 41.4947L22.959 41.4947C21.9809 41.4972 21.0823 40.8433 20.7708 39.8554L20.7708 39.8553L20.155 37.9022C20.1549 37.9018 20.1548 37.9013 20.1546 37.9008C19.881 37.0258 19.3441 36.2406 18.5948 35.6876C18.5944 35.6873 18.5939 35.687 18.5935 35.6866L16.9596 34.4763L16.9589 34.4757C16.1465 33.8751 15.7995 32.8092 16.1161 31.821L16.1164 31.8204L16.7474 29.8463L16.7475 29.8461C17.0283 28.9668 17.0283 28.0286 16.7475 27.1493L16.7466 27.1465L16.1161 25.1928C16.1161 25.1925 16.116 25.1923 16.1159 25.192C15.7989 24.2016 16.1487 23.1178 16.9601 22.515C16.9602 22.5149 16.9604 22.5149 16.9605 22.5148L18.5935 21.3051C18.5938 21.3049 18.5941 21.3046 18.5944 21.3044C19.3372 20.7564 19.8783 19.989 20.1546 19.1094L20.1551 19.1079L20.7711 17.1356C20.7712 17.1353 20.7713 17.135 20.7714 17.1346C21.0827 16.1458 21.9752 15.4958 22.956 15.497L24.9617 15.5154V15.5154L24.9656 15.5154C25.8797 15.5202 26.7891 15.2278 27.5323 14.6715L27.5323 14.6715L27.5363 14.6684L29.1549 13.444C29.516 13.1748 29.9397 13.0282 30.369 13.0037H30.5018H30.6321C31.0558 13.0277 31.4778 13.1736 31.8449 13.4475C31.8456 13.448 31.8462 13.4485 31.8469 13.449L33.4637 14.6721L33.4637 14.6722L33.4711 14.6777C34.2124 15.2278 35.1149 15.5191 36.0291 15.5191V15.5192L36.0383 15.5191L38.041 15.5007C38.042 15.5007 38.043 15.5007 38.044 15.5007C39.0206 15.4995 39.9174 16.1526 40.2288 17.1389C40.2289 17.1393 40.229 17.1396 40.2292 17.14L40.8449 19.1116L40.8454 19.1131C41.1217 19.9929 41.663 20.7604 42.406 21.3084C42.4062 21.3085 42.4063 21.3086 42.4065 21.3088L44.0404 22.5191L44.0411 22.5197C44.8506 23.1182 45.2013 24.2009 44.8841 25.192C44.884 25.1923 44.8839 25.1925 44.8839 25.1928L44.2534 27.1465L44.2525 27.1493C43.9717 28.0286 43.9717 28.9668 44.2525 29.8461L44.2526 29.8463L44.8836 31.8204L44.8839 31.821C45.2009 32.8104 44.8524 33.8785 44.0428 34.4745L44.0404 34.4763L42.4065 35.6866C42.4061 35.6869 42.4057 35.6872 42.4054 35.6875C41.6546 36.2414 41.1189 37.0308 40.8457 37.8997L33.4677 42.3387ZM24.9709 42.4947H22.9616H24.9709Z"
          stroke="#E7ECF3"
          strokeWidth="2"
        />
      </g>
      <path
        d="M29.0114 29.7928C29.3963 30.7092 30.195 31.3028 31.1469 31.3028C31.9126 31.3028 32.5623 30.9323 32.5623 30.243C32.5623 29.7291 32.194 29.3785 31.4118 29.1195L30.0957 28.6534C28.4941 28.1076 27.4635 27.1594 27.4635 25.6374C27.4635 23.9681 28.6472 22.7809 30.3151 22.51V21H31.9829V22.5578C33.2162 22.8127 34.2675 23.6016 34.8179 24.741L32.852 25.8327C32.5168 25.1275 31.9333 24.5657 31.1014 24.5657C30.3854 24.5657 29.8846 24.9363 29.8846 25.498C29.8846 26.012 30.2861 26.2988 30.969 26.5578L32.3844 27.0876C34.1516 27.7131 35 28.6773 35 30.1195C35 31.9163 33.6508 33.0717 31.9829 33.3785V35H30.3151V33.3944C28.8334 33.1554 27.5835 32.2869 27 30.8606L29.0155 29.8008L29.0114 29.7928Z"
        fill="#33B083"
      />
      <defs>
        <filter
          id="filter0_dd_1283_578"
          x="0"
          y="0.3"
          width="61"
          height="63"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1283_578"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.04 0"
          />
          <feBlend mode="multiply" in2="BackgroundImageFix" result="effect1_dropShadow_1283_578" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_1283_578"
          />
          <feOffset dy="3.3" />
          <feGaussianBlur stdDeviation="9" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.09 0"
          />
          <feBlend
            mode="multiply"
            in2="effect1_dropShadow_1283_578"
            result="effect2_dropShadow_1283_578"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1283_578"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
export default DollarBadge
